import { createContext } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AccountContext = createContext<any | undefined>(undefined);